/* tslint:disable:member-ordering */
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';
import { AuthManagerService } from '../api/auth/auth-manager.service';
import { AuthenticatedUser } from '../api/auth/authenticated-user.model';

@Injectable({
    providedIn: 'root'
})
export class LoginGuardService implements CanActivate, CanActivateChild
{
    private static navElements = [
        { route: 'content/news', property: 'News', isGlobalAdmin: false },
        { route: 'content/events', property: 'Events', isGlobalAdmin: false },
        { route: 'content/albums', property: 'Photos', isGlobalAdmin: false },
        { route: 'content/doc-center', property: 'DocumentCenter', isGlobalAdmin: false },
        { route: 'notifications', property: 'Notifications', isGlobalAdmin: false },
        { route: 'check-in-check-out', property: 'CheckInCheckOut', isGlobalAdmin: false },
        { route: 'users/manageUsers', property: 'Members', isGlobalAdmin: false },
        { route: 'users/categories', property: 'Categories', isGlobalAdmin: false },
        { route: 'org/contacts', property: 'Contacts', isGlobalAdmin: false },
        { route: 'org/info', property: 'OrganizationInfo', isGlobalAdmin: false },
        { route: 'org/more', property: 'Locations', isGlobalAdmin: false },
        { route: 'sponsors', property: 'Sponsors', isGlobalAdmin: false },
        { route: 'reports', property: 'Reports', isGlobalAdmin: false },
        { route: 'admin/themes', property: 'Themes', isGlobalAdmin: true },
        { route: 'admin/orgSettings', property: 'OrgSettings', isGlobalAdmin: true },
        { route: 'admin/orgAdmins', property: 'OrgAdmins', isGlobalAdmin: true },
        { route: 'admin/orgDataSync', property: 'OrgSettings', isGlobalAdmin: true },
        { route: 'admin/createOrg', property: 'CreateOrg', isGlobalAdmin: true },
        { route: 'admin/reviewFaceDetection', property: 'FaceDetection', isGlobalAdmin: true },
        { route: 'admin/appStatus', property: 'AppStatus', isGlobalAdmin: true },
        { route: 'admin/generalSettings', property: 'GeneralSettings', isGlobalAdmin: true },
        { route: 'admin/globalAdmins', property: 'EditGlobalAdmins', isGlobalAdmin: true },
        { route: 'admin/globalAdminReport', property: 'EditGlobalAdmins', isGlobalAdmin: true },
    ];

    constructor(private router: Router,
                private authManager: AuthManagerService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot)
    {
        // console.log(`Checking route: ${state.url}`);
        return this.checkLogin(state.url);
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot)
    {
        return this.canActivate(route, state);
    }

    private checkLogin(url: string): boolean
    {
        if (!this.authManager.authenticatedUser || !this.authManager.authenticatedUser.isLoggedIn()) {
            this.router.navigate(['/account/sign-in']);
            return false;
        }

        if (url.indexOf('/section') === 0)
        {
            const route = url.substring(9);
            if (!LoginGuardService.isNavAccessible(this.authManager.authenticatedUser, route))
            {
                this.router.navigate(['/account/sign-in']);
                return false;
            }
        }

        return true;
    }

    private static isNavAccessible(authenticatedUser: AuthenticatedUser, route: string): boolean
    {
		// See if this is a protected route
        const navElement = LoginGuardService.navElements.find(ne => route.startsWith(ne.route));
		if (navElement === undefined) return true;

		// See if this is an admin route and is not a global admin (disallowed) or is not an admin route and is a global admin (allowed)
	    if (navElement.isGlobalAdmin && !authenticatedUser.isGlobalAdmin) return false;
	    if (!navElement.isGlobalAdmin && authenticatedUser.isGlobalAdmin) return true;

		// Check access to this route
        if (authenticatedUser.accessInfo == undefined) return true;
        return  authenticatedUser.accessInfo["EditGlobalAdmins"] === true || authenticatedUser.accessInfo[navElement.property] === true;
    }

    static firstAvailableComponent(authenticatedUser: AuthenticatedUser): string
    {
        for (const navElement of LoginGuardService.navElements)
        {
            if (LoginGuardService.isNavAccessible(authenticatedUser, navElement.route)) return navElement.route;
        }

        return '/account/sign-in';
    }
}
